import type { WmsAccessSummary } from '$lib/api/modules-access';
import { ArrowRightLeft, Boxes, Bot, ListChecks, PackageCheck, Printer, ScanLine, Settings2 } from '@lucide/svelte';

export type WmsShortcut = {
  key: string;
  title: string;
  description: string;
  href: string;
  icon: typeof Boxes;
};

const shortcuts = [
  { key: 'mottak', title: 'vms.receiving.title', description: 'vms.app.shortcutDescriptions.receiving', icon: PackageCheck, access: 'source' },
  { key: 'telling', title: 'vms.counting.title', description: 'vms.app.shortcutDescriptions.counting', icon: ScanLine, access: 'source' },
  { key: 'flytt', title: 'vms.moveStock.workspaceShortcut.title', description: 'vms.moveStock.workspaceShortcut.description', icon: ArrowRightLeft, access: 'source' },
  { key: 'oppgaver', title: 'vms.workItems.workspaceShortcut.title', description: 'vms.workItems.workspaceShortcut.description', icon: ListChecks, access: 'source' },
  { key: 'etiketter', title: 'vms.productLabels.workspaceShortcut.title', description: 'vms.productLabels.workspaceShortcut.description', icon: Printer, access: 'source' },
  { key: 'plukklister', title: 'vms.pickLists.title', description: 'vms.app.shortcutDescriptions.pickLists', icon: Printer, access: 'picking' },
  { key: 'plukk', title: 'vms.picking.title', description: 'vms.app.shortcutDescriptions.picking', icon: Boxes, access: 'picking' },
  { key: 'lokasjoner', title: 'vms.locationModel.workspaceShortcut.title', description: 'vms.locationModel.workspaceShortcut.description', icon: Boxes, access: 'source' },
  { key: 'varerobot', title: 'vms.app.robot', description: 'vms.app.shortcutDescriptions.robot', icon: Bot, access: 'robot' },
  { key: 'settings', title: 'menu.settings', description: 'vms.app.shortcutDescriptions.settings', icon: Settings2, access: 'source' }
] as const;

export function getWmsShortcuts(access: WmsAccessSummary, tr: (key: string) => string): WmsShortcut[] {
  if (!access.canAccessModule) return [];
  const robotInventory = access.canReadVarerobotInventory || access.canWriteVarerobotInventory;
  return shortcuts.filter((item) => item.access === 'source'
    ? access.canReadSourceInventory
    : item.access === 'picking'
      ? access.canReadSourceInventory || robotInventory
      : robotInventory || access.canRunSync
  ).map((item) => ({
    key: item.key, title: tr(item.title), description: tr(item.description),
    href: `/wms/${item.key}`, icon: item.icon
  }));
}
